import React from 'react';
import DataTable from 'react-data-table-component';
import { CustomPaginacion } from './Paginacion'

import './tabla.css';

export const xs = '80px'
export const small = '100px'
export const medium = '150px'
export const large = '170px'
export const xl = '200px'
export const xxl = '250px'

const customStyles = {
	headCells: {
		style: {
			textAlign: 'center',
		},

	},
	cells: {
		style: {

		}
	},
	rows: {
		style: {

		}
	},
};

const paginationComponentOptions = {
	rowsPerPageText: 'Registros por página:',
	rangeSeparatorText: 'de',
	noRowsPerPage: false,
	selectAllRowsItem: false,
	selectAllRowsItemText: 'Todos',
};

const RadioButton = React.forwardRef(({ onClick, ...rest }, ref) => (
	<label class='kt-radio'>
		<input ref={ref} {...rest} type='radio' />
		<span onClick={onClick}></span>
	</label>
));

const CheckBox = React.forwardRef(({ onClick, ...rest }, ref) => (
	<label class='kt-checkbox'>
		<input type='checkbox' ref={ref} {...rest} />
		<span onClick={onClick}></span>
	</label>
));

const FilterComponent = ({ filterText, onFilter }) => (
	<>
		<div class='col-sm-12 col-md-6'>
			<div id='kt_table_factoring_filter' class='dataTables_filter'>
				<label className='d-flex'>
					<span className='dataTables_search'>Buscar: </span>
					<input autoComplete="new-off" className='form-control form-control-sm' id='search' type='text' value={filterText} onChange={onFilter} />
				</label>
			</div>
		</div>
	</>
);

const NoDataComponent = ({text}) =><p className='m-3 text-muted'>{text?text:"No existen registros que mostrar."}</p>;

const Tabla = ({ busqueda, textNoData="", paginacion, numeroFilas = 3, conditionalRowStyles, direction = "ltr", toggledClearRows, selectableRowSelected, selectableRowsNoSelectAll, selectableRowsSingle, inputType, selectableRowDisabled,
	onSelectedRowsChange, selectableRows, datos: { columns = [], rows = [] } , expandable = false,onRowExpandToggled, expandableRowExpanded, expandableRowsComponent}) => {
	const [filterText, setFilterText] = React.useState('');
	const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);

	const onSort = (selectedColumn, sortDirection, sortedRows)=>{
		setResetPaginationToggle(true);
	}
	const filteredItems = rows.filter(item => {
		return columns.some(col => {
			if(col.name === "Contrato"){
				return item.nu_operacion.toString().toLowerCase().includes(filterText.toLowerCase())?item:false
			}
			const value = ( typeof col.selector(item) === 'object')?(col.selector(item).props.children):(col.selector(item));
			return value &&
			value
			 .toString()
			 .toLowerCase()
			 .includes(filterText.toLowerCase())
			 ? item
			 : false
		})
	});
	const subHeaderComponentMemo = React.useMemo(() => {
		return <FilterComponent onFilter={e => setFilterText(e.target.value)} filterText={filterText} />;
	}, [filterText, resetPaginationToggle]);
	return (
		<DataTable
			title='Bandeja'
			/* Data */
			data={filteredItems}
			columns={columns}
			/* Properties */
			//subHeader
			noHeader
			persistTableHead
			noTableHead={false}
			direction={direction}
			/* Searchbox */
			subHeader={busqueda}
			/* Pagination */
			pagination={paginacion}
			paginationDefaultPage={1}
			paginationResetDefaultPage={resetPaginationToggle}
			paginationComponent={CustomPaginacion}
			paginationPerPage={numeroFilas}
			paginationRowsPerPageOptions={[10, 20, 30, 50]}
			/* Messages */
			paginationComponentOptions={paginationComponentOptions}
			/* Components */
			noDataComponent={<NoDataComponent text={textNoData} />}
			subHeaderComponent={busqueda ? subHeaderComponentMemo : <></>}
			/* Checkboxs */
			selectableRows={selectableRows}
			//selectableRowsComponent={inputType === 'radio' ? RadioButton : CheckBox}
			selectableRowsComponentProps={{type : inputType==='radio'?"radio":"checkbox"}}
			selectableRowDisabled={selectableRowDisabled}
			onSelectedRowsChange={onSelectedRowsChange}
			selectableRowSelected={selectableRowSelected}
			clearSelectedRows={toggledClearRows}
			/*Radio*/
			selectableRowsNoSelectAll={selectableRowsNoSelectAll}
			selectableRowsSingle={selectableRowsSingle}
			/* Conditional styles */
			conditionalRowStyles={conditionalRowStyles}
			/* Styles */
			customStyles={customStyles}
			/* Expandable */
			expandableRows={expandable}
			onRowExpandToggled={onRowExpandToggled}
			expandableRowExpanded={expandableRowExpanded}
			expandableRowsComponent={expandableRowsComponent}
			/* Sorting*/
			onSort={onSort}
		/>
	);
};

Tabla.defaultProps = {
	datos: {
		rows: [],
		columns: [],
	},
	rows: [],
	columns: [],
	conditionalRowStyles: [],
	paginacion: true,
	busqueda: true,
	inputType: 'checkbox',
	selectableRows: false,
	onSelectedRowsChange: () => { },
	selectableRowsComponent: null,
};

export default Tabla;

